import { ModalWindow } from '@components/Modal/ModalWindow';
import { ModalWindowTitle } from '@components/Modal/ModalWindowTitle';
import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { useData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IVendedorMovimentacaoLinha } from '@model/VendedorMovimentacaoLinha';
import { useVendedorMovimentacaoService } from '@services/VendedorMovimentacaoService';
import React from 'react';

export type VendedorMovimentacaoDetalhesModalProps = {
    modal: IModalWindow
    vendedorMovimentacaoId: number
}

export function VendedorMovimentacaoDetalhesModal ({ modal, vendedorMovimentacaoId }: VendedorMovimentacaoDetalhesModalProps) {
    const loading = useLoading();
    const message = useMessage();
    const formatter = useFormatter();
    const vendedorMovimentacaoLinhaData = useData<IVendedorMovimentacaoLinha>();
    const vendedorMovimentacaoService = useVendedorMovimentacaoService();

    const handleEnter = React.useCallback(() => {
        if (!loading.isLoading) {
            loading.start();
            vendedorMovimentacaoService.listarLinhas(vendedorMovimentacaoId)
                .then(vendedorMovimentacaoLinhaData.handleDataResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    }, [loading, message.showException, vendedorMovimentacaoLinhaData.handleDataResponse, vendedorMovimentacaoId, vendedorMovimentacaoService]);

    return (
        <ModalWindow 
            modal={modal}
            size="md"
            disabled={loading.isLoading}
            TransitionProps={{
                onEnter: handleEnter
            }}
        >
            <ModalWindowTitle
                title={`Detalhes da Movimentação ${vendedorMovimentacaoId}`}
            />

            <TableLinearLoading isLoading={loading.isLoading} />

            <Table>
                <TableHead>
                    <TableRow>
                        <TableHeaderCell>ID</TableHeaderCell>
                        <TableHeaderCell>Número</TableHeaderCell>
                        <TableHeaderCell>Empresa</TableHeaderCell>
                        <TableHeaderCell>Operadora</TableHeaderCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {
                        vendedorMovimentacaoLinhaData.items.map((vendedorMovimentacaoLinha, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell>{vendedorMovimentacaoLinha.vendedorMovimentacaoLinhaId}</TableKeyCell>
                                    <TableCell>{formatter.toCelular(vendedorMovimentacaoLinha.linha.numeroSemMascara)}</TableCell>
                                    <TableCell>{vendedorMovimentacaoLinha.linha.contratoOperadoraEmpresaNome}</TableCell>
                                    <TableCell>{vendedorMovimentacaoLinha.linha.contratoOperadoraOperadoraNome}</TableCell>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
        </ModalWindow>
    )
}